import FaqRoute from "./faq";

// Rules is effectively a faq alias
export default class RulesRoute extends FaqRoute {
  pageId = "rules";
}